import MainFrame from '@/views/MainFrame'
var menus=[
    {
        path: '/',
        name: 'main-frame',
        component: MainFrame,
        redirect:'/home',
        children:[
            {
                path: '/home',
                name: 'home',
                component: ()=>import('@/views/Home'),
            },
            {
                path: '/mine',
                name: 'mine',
                component: ()=>import('@/views/Mine'),
            },
            {
                path: '/data',
                name: 'data',
                component: ()=>import('@/views/Data'),
            },
            {
                path: '/my-info',
                name: 'my-info',
                component: ()=>import('@/views/Mine/MyInfo'),
            },
            {
                path: '/my-score',
                name: 'my-score',
                component: ()=>import('@/views/Mine/MyScore'),
            },
            {
                path: '/score-list',
                name: 'score-list',
                component: ()=>import('@/views/Mine/ScoreList'),
            },
            {
                path: '/mat',
                name: 'mat',
                component: ()=>import('@/views/MAT/NewEvaluating')
            },
            {
                path: '/mat-report',
                name: 'mat-report',
                component: ()=>import('@/views/MAT/Report')
            },
            {
                path: '/mat-sel',
                name: 'mat-sel',
                component: ()=>import('@/views/MAT/EvaluatingChoose')
            },
            {
                path: '/aso',
                name: 'aso',
                component: ()=>import('@/views/SubjectEvaluating/SubjectEvaluating')
            },
            {
                path: '/aso-sel',
                name: 'aso-sel',
                component: ()=>import('@/views/SubjectEvaluating/EvaluatingChooseSubject')
            },
            {
                path: '/aso-report',
                name: 'aso-report',
                component: ()=>import('@/views/SubjectEvaluating/SubjectEvaluatingReport')
            },
            {
                path: '/unvcompare',
                name: 'unvcompare',
                component: ()=>import('@/views/InfoSearch/UnvCompareDetail')
            },
            {
                path: '/unv-info',
                name: 'unv-info',
                component: ()=>import('@/views/InfoSearch/UnvInfoSearch'),
            },
            {
                path: '/major-info',
                name: 'major-info',
                component: ()=>import('@/views/InfoSearch/MajorInfoSearch'),
            },
            {
                path: '/city-info',
                name: 'city-info',
                component: ()=>import('@/views/InfoSearch/CityInfoSearch'),
            },
            {
                path: '/unv-compare',
                name: 'unv-compare',
                component: ()=>import('@/views/InfoSearch/UnvInfoCompare'),
            },
            {
                path: '/major-compare',
                name: 'major-compare',
                component: ()=>import('@/views/InfoSearch/MajorCompareSearch'),
            },
            {
                path: '/fav-unv',
                name: 'fav-unv',
                component: ()=>import('@/views/MyFavorite/unvs'),
            },
            {
                path: '/fav-major',
                name: 'fav-major',
                component: ()=>import('@/views/MyFavorite/majors'),
            },
            {
                path: '/fav-city',
                name: 'fav-city',
                component: ()=>import('@/views/MyFavorite/cities'),
            },
            {
                path: '/job-data',
                name: 'job-data',
                component: ()=>import('@/views/JobData')
            },
            {
                path: '/batch-score',
                name: 'batch-score',
                component: ()=>import('@/views/BatchScore'),
            },
            {
                path: '/yfyd',
                name: 'yfyd',
                component: ()=>import('@/views/YFYD'),
            },
            {
                path: '/unv-detail',
                name: 'unv-detail',
                component: ()=>import('@/views/DetailInfo/UnvDetail'),
            },
            {
                path: '/major-detail',
                name: 'major-detail',
                component: ()=>import('@/views/DetailInfo/MajorDetail'),
            },
            {
                path: '/city-detail',
                name: 'city-detail',
                component: ()=>import('@/views/DetailInfo/CityDetail'),
            },
            {
                path: '/mcd',
                name: 'major-compare-detail',
                component: ()=>import('@/views/InfoSearch/MajorCompareDetail'),
            },
            {
                path: '/ucd',
                name: 'unv-compare-detail',
                component: ()=>import('@/views/InfoSearch/UnvCompareDetail'),
            },
            {
                path: '/zsjz',
                name: 'zsjz',
                component: ()=>import('@/views/ZSJZ'),
            },
            {
                path: '/unv-rank',
                name: 'unv-rank',
                component: ()=>import('@/views/Ranks/UnvRank'),
            },
            {
                path: '/major-rank',
                name: 'major-rank',
                component: ()=>import('@/views/Ranks/MajorRank'),
            },
            {
                path: '/major-unv-rank',
                name: 'major-unv-rank',
                component: ()=>import('@/views/Ranks/MajorUnvRanks'),
            },
            {
                path: '/contact-qr',
                name: 'contact-qr',
                component: ()=>import('@/views/ContactUs/ContactQR.vue'),
            },
        ]
    },
]

export default [
    ...menus,
    //下面这几组 不属于菜单显示范围 且没有子菜单 可以省略title icon等菜单专用属性
    {
        path: '/login',
        name: 'login',
        component: ()=>import('@/views/Login')
    },
    {
        path: '/supergo',
        name: 'supergo',
        component: ()=>import('@/views/DirectlyLogin')
    },
    {
        path: '/error',
        name: 'error',
        component: ()=>import('@/views/ErrorPage')
    },
]